module.exports = __webpack_public_path__ + "static/img/content5.b230d248.png";